import { createRouter, createWebHistory } from 'vue-router'
import { checkUser } from '@/constants/global/router'
import mainPage from '@/pages/mainPage.vue'

const routes = [
  {
    path: '/',
    name: 'root',
    redirect: { name: 'main' }
  },
  {
    path: '/main',
    name: 'main',
    component: mainPage
  },
  {
    path: '/:catchAll(.*)',
    redirect: { name: 'main' }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async to => {
  let checkList = [checkUser]
  for (let check of checkList) {
    let result = await check(to)
    return result
  }
  return true
})

export default router
